// ERRORS
export const ERROR_GET_BILLING_SERVER = 'Failed to load BILLING. Please try again later.'
